import { render, staticRenderFns } from "./partner-community.vue?vue&type=template&id=fc2560d4&scoped=true&"
import script from "./partner-community.vue?vue&type=script&lang=js&"
export * from "./partner-community.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2560d4",
  null
  
)

export default component.exports